import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M1.2 16v-4H0v4c0 1.1.9 2 2 2h4v-1.2H2a.81.81 0 0 1-.8-.8zm0-14c0-.434.366-.8.8-.8h4V0H2C.9 0 0 .9 0 2v4h1.2V2zm15.6 14a.81.81 0 0 1-.8.8h-4V18h4c1.1 0 2-.9 2-2v-4h-1.2v4zM16 0h-4v1.2h4c.434 0 .8.366.8.8v4H18V2c0-1.1-.9-2-2-2zM5 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-.402 4.387c-1.45 1.307-3.746 1.307-5.196 0l-.804.891C6.544 13.131 7.752 13.6 9 13.6s2.456-.469 3.402-1.322l-.804-.891z" />
  </svg>
);

export default SvgComponent;
